// app/javascript/modules/ferias/form_adiantamento13.js
// Desabilita o adiantamento de 13º quando o início das férias é em janeiro.

export function initFeriasAdiantamento13(form) {
  const inicioInput    = form.querySelector('#params_inicio')
  const wrapper        = form.querySelector('[data-ferias-field="adiantamento13"]')
  const adiantamentoCb = form.querySelector('#params_adiantamento_da_1_parcela_do_13')

  function getMonth() {
    const val = inicioInput?.value || ''
    const br  = val.match(/^(\d{2})\/(\d{2})\/\d{4}$/)
    if (br) return br[2]
    const iso = val.match(/^\d{4}-(\d{2})-\d{2}$/)
    if (iso) return iso[1]
    return null
  }

  function apply() {
    const isJaneiro = getMonth() === '01'
    if (wrapper)        wrapper.style.opacity          = isJaneiro ? '0.5' : '1'
    if (adiantamentoCb) adiantamentoCb.disabled        = isJaneiro
    if (isJaneiro && adiantamentoCb) adiantamentoCb.checked = false
  }

  inicioInput?.addEventListener('change', apply)
  apply()

  return {
    apply,
    destroy() {
      inicioInput?.removeEventListener('change', apply)
    }
  }
}
